import React from 'react';

const AssetContext = React.createContext({
  _refresh: () => null
});
export default AssetContext;